import { DrilldownFieldType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import _ from 'lodash'
import { FC } from 'react'

import { EmptyValue, formatValueForDisplay } from './utils'

export interface PropertyValueRendererProps {
  type: DrilldownFieldType
  value: unknown
}

export const PropertyValueRenderer: FC<PropertyValueRendererProps> = ({
  type,
  value,
}) => {
  if (_.isNil(value) || value === '') {
    return <EmptyValue>—</EmptyValue>
  }

  const displayValue = formatValueForDisplay(value, type)
  return <span>{displayValue}</span>
}
